import Head from 'next/head';
import type {FC} from 'react';
import {COLUMN_CRUMB} from '../../../../config/constants/crumb';
import {COLUMNS} from '../../../../config/constants/routes';
import type {PostSchema} from '../../../../core/entities/columns/schema';
import {BreadcrumbsComponent} from '../../../../shared/components/BreadcrumbsComponent';
import {createBreadCrumbsStructuredData} from '../../../../shared/services/createBreadCrumbsStructuredData';
import {useMediaQuery} from '../../../../shared/services/useMediaQuery';

type Props = {
  post: PostSchema;
};
export const Breadcrumbs: FC<Props> = ({post}) => {
  const {isPC} = useMediaQuery();
  const crumbs = [
    {label: COLUMN_CRUMB, href: COLUMNS},
    ...(post.categoryJP
      ? [
          {
            label:
              !isPC && post.categoryJP.length > 5
                ? `${post.categoryJP.slice(0, 5)}...`
                : post.categoryJP,
            href: `/column/category/${post.category}`,
          },
        ]
      : []),
    ...(post.subCategoryJP
      ? [
          {
            label:
              !isPC && post.subCategoryJP.length > 5
                ? `${post.subCategoryJP.slice(0, 5)}...`
                : post.subCategoryJP,
            href: `/columns/category/${post.category}/${post.subCategory}`,
          },
        ]
      : []),
    {
      label:
        isPC && post.title.length > 20
          ? `${post.title.slice(0, 20)}...`
          : !isPC && post.title.length > 10
            ? `${post.title.slice(0, 10)}...`
            : post.title,
      href: `/archives/${post.id}`,
    },
  ];

  return (
    <>
      <Head>
        <script type="application/ld+json">
          {JSON.stringify(createBreadCrumbsStructuredData(crumbs))}
        </script>
      </Head>
      <div className="px-16 w-full max-w-[1200px] mx-auto">
        <div className="h-24 hidden pc:block my-16">
          <BreadcrumbsComponent crumbs={crumbs} />
        </div>
      </div>
    </>
  );
};
